import {
    INCIDENT_CONTAINED_BY_PROCESSING,
    INCIDENT_CONTAINED_BY_REQUESTED,
    INCIDENT_CONTAINED_BY_SUCCESSED,
    INCIDENT_CONTAINED_BY_FAILED,
  } from '../../constants/actionTypes';
   
  const initialState = {
    result: {},
    isProcessing: null,
    isSuccess: null,
    hasErrors: null,
  };
  
  export const incidentMasterContainedBy = (state = initialState, action) => {
    switch (action.type) {
      case INCIDENT_CONTAINED_BY_REQUESTED: {
        return {
          ...state,
          error: null,
          loading: true,
          requested: true,
        };
      }
      case INCIDENT_CONTAINED_BY_PROCESSING: {
        return {
          ...state,
          error: null,
          loading: true,
          requested: false,
        };
      }
      case INCIDENT_CONTAINED_BY_SUCCESSED: {
        return {
          ...state,
          result: action.data,
          error: null,
          loading: false,
          requested: false,
        };
      }
      case INCIDENT_CONTAINED_BY_FAILED: {
        return {
          ...state,
          result: {},
          error: action.data,
          loading: false,
          requested: false,
        };
      }
  
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default incidentMasterContainedBy;
  